<button id="kt_open_listforms_drawer" 
class="btn btn-sm btn-primary btn-activity-toggle">
    <i  class="fa fa-plus"
    data-toggle="popover"
    data-trigger="hover"
    data-html="true"
    [popover]="popTemplate"
    triggers="mouseenter:mouseleave"></i>
    <ng-template #popTemplate>
        <div class="tooltip-div">{{ l('SelectaForm') }}</div>
    </ng-template>
</button> 
